export default __webpack_public_path__ + "static/media/useLocationWhiteIcon.d91feb7f.svg";